import { Box, TextField } from "@mui/material";
import { useState } from "react";
import { AxleOrgSyncOrgFragment, useAxleOrgSyncOrgsQuery, useCreateAxleOrgSyncJobMutation } from "../../../../types";
import { OrgsListSynced, OrgsListUnlinked } from "../../../../views/Staff/Orgs/Sync/Orgs/Axle";
import ListsColumn from "../../../../views/Staff/Orgs/Sync/shared/ListColumn";

export const AxleOrgsSyncPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedNutritionOrg, setSelectedNutritionOrg] = useState<AxleOrgSyncOrgFragment | null>(null);
  const [axleLinkDialogOpen, setAxleLinkDialogOpen] = useState(false);

  const { data, loading } = useAxleOrgSyncOrgsQuery();
  const [createAxleOrgSyncJob] = useCreateAxleOrgSyncJobMutation();

  const baseListProps = {
    selectedId: selectedNutritionOrg?.id ?? null,
    searchQuery: searchTerm,
  };

  const baseNutritionOrgProps = {
    ...baseListProps,
    orgs: data?.orgs ?? [],
    loading,
  };

  const handleNutritionOrgLinkClick = (org: AxleOrgSyncOrgFragment) => {
    setSelectedNutritionOrg(org);
    setAxleLinkDialogOpen(true);
  };

  const dryRunNutritionOrgSync = (org: AxleOrgSyncOrgFragment, axleOrgId: string) => {
    //TODO: implement dry run - preview what would be synced without actually syncing
    console.log("Dry run sync for org", org.id, "with Axle org", axleOrgId);
  };

  // const linkAndSyncNutritionOrg = async (org: AxleOrgSyncOrgFragment, axleOrgId: string) => {
  //   try {
  //     await createAxleOrgSyncJob({
  //       variables: {
  //         input: {
  //           axleOrgDocumentId: axleOrgId,
  //         },
  //       },
  //     });
  //     console.log("Successfully queued sync job for org", org.id, "with Axle org", axleOrgId);
  //     setAxleLinkDialogOpen(false);
  //     setSelectedNutritionOrg(null);
  //   } catch (error) {
  //     console.error("Failed to queue sync job:", error);
  //   }
  // };

  const syncNutritionOrg = async (org: AxleOrgSyncOrgFragment) => {
    if (!org.axleOrgDocumentId) {
      console.error("Cannot sync org - no axleOrgDocumentId");
      return;
    }

    try {
      await createAxleOrgSyncJob({
        variables: {
          input: {
            axleOrgDocumentId: org.axleOrgDocumentId,
          },
        },
      });
      console.log("Successfully queued sync job for org", org.id);
    } catch (error) {
      console.error("Failed to queue sync job:", error);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, height: "100%", overflow: "hidden", flex: 1 }}>
      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", alignItems: "flex-end" }}>
        <TextField sx={{ width: 350 }} label="Filter Orgs" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 2,
          height: "100%",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <ListsColumn>
          <OrgsListUnlinked {...baseNutritionOrgProps} onLink={handleNutritionOrgLinkClick} />
        </ListsColumn>
        <ListsColumn>
          <OrgsListSynced {...baseNutritionOrgProps} onSync={syncNutritionOrg} />
        </ListsColumn>
      </Box>

      {/* {selectedNutritionOrg && axleLinkDialogOpen && (
        <AxleLinkDialog
          nutritionOrg={selectedNutritionOrg}
          onClose={() => {
            setSelectedNutritionOrg(null);
            setAxleLinkDialogOpen(false);
          }}
          onDryRun={axleOrgId => dryRunNutritionOrgSync(selectedNutritionOrg, axleOrgId)}
          onLinkAndSync={axleOrgId => linkAndSyncNutritionOrg(selectedNutritionOrg, axleOrgId)}
        />
      )} */}
    </Box>
  );
};
